import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { LocationProvider } from "./lib/locationContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Restaurants from "./pages/Restaurants";
import RestaurantDetail from "./pages/RestaurantDetail";
import Influencers from "./pages/Influencers";
import InfluencerDetail from "./pages/InfluencerDetail";
import MapView from "./pages/MapView";
import AuthCallback from "./pages/AuthCallback";
import DashboardLayout, { DashboardHome } from "./pages/Dashboard";
import { MyRestaurants, RestaurantForm } from "./pages/RestaurantManage";
import { MyReviews, ReviewForm } from "./pages/ReviewManage";
import Profile from "./pages/Profile";
import FeaturedSpots from "./pages/FeaturedSpots";
import FeaturedSuccess from "./pages/FeaturedSuccess";
import Bookmarks from "./pages/Bookmarks";
import BannerAds from "./pages/BannerAds";
import AdSuccess from "./pages/AdSuccess";
import Login from "./pages/Login";
import VerifyEmail from "./pages/VerifyEmail";
import { MyBookings, OwnerBookings } from "./pages/Bookings";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);

  return null;
};

const AppRouter = () => {
  if (window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Header />
      <main className="min-h-[calc(100vh-4rem)]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/restaurants" element={<Restaurants />} />
          <Route path="/restaurants/:slug" element={<RestaurantDetail />} />
          <Route path="/influencers" element={<Influencers />} />
          <Route path="/influencers/:id" element={<InfluencerDetail />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardHome />} />
            <Route path="restaurants" element={<MyRestaurants />} />
            <Route path="restaurants/new" element={<RestaurantForm />} />
            <Route path="restaurants/:id/edit" element={<RestaurantForm />} />
            <Route path="reviews" element={<MyReviews />} />
            <Route path="reviews/new" element={<ReviewForm />} />
            <Route path="featured" element={<FeaturedSpots />} />
            <Route path="featured/success" element={<FeaturedSuccess />} />
            <Route path="ads" element={<BannerAds />} />
            <Route path="ads/success" element={<AdSuccess />} />
            <Route path="bookmarks" element={<Bookmarks />} />
            <Route path="bookings" element={<MyBookings />} />
            <Route path="bookings-incoming" element={<OwnerBookings />} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Routes>
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LocationProvider>
          <AuthProvider>
            <ScrollToTop />
            <AppRouter />
            <Toaster richColors position="top-right" />
          </AuthProvider>
        </LocationProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
